import { render } from "./MyDepartment.vue?vue&type=template&id=79e3a7de&scoped=true"
import script from "./MyDepartment.vue?vue&type=script&lang=js"
export * from "./MyDepartment.vue?vue&type=script&lang=js"

import "./MyDepartment.vue?vue&type=style&index=0&id=79e3a7de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e3a7de"]])

export default __exports__